import React, { useState } from 'react';
import { Navbar, Container, Button, Dropdown, Icon } from 'rbx';
import logoImage from '../../assets/images/logo-transitar.png';
import "../../styles/header.scss";
import UserService from '../../services/user';
import { Redirect } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'


const HeaderLogged = (props) => {
  const user = JSON.parse(sessionStorage.getItem('user'));
  const [redirectTo, setRedirectTo] = useState(null);

  const logout = async () => {
    await UserService.logout();
    setRedirectTo("/");
  }

  if (redirectTo && redirectTo!==window.location.pathname)
    return <Redirect to={{ pathname: redirectTo }} />

  const namesArray = user.name.split(' ');
  const firstAndLastName = `${namesArray[0]} ${namesArray[namesArray.length-1]}`

  return (
    <Navbar>
      <Container className='is-max-widescreen'>
        <Navbar.Brand className="ml-0">
          <img src={logoImage} alt="logoImage" onClick={()=>setRedirectTo('/dashbord')} style={{cursor: 'pointer'}} />
          <Navbar.Burger />
        </Navbar.Brand>

        <Navbar.Menu id="navbar-menu" className="ml-4">
          <Navbar.Segment align="start">
            <Navbar.Item onClick={()=>setRedirectTo('/dashbord')}>Dashbord</Navbar.Item>
            <Navbar.Item onClick={()=>setRedirectTo('/app/find')}>App</Navbar.Item>
            <Navbar.Item onClick={()=>setRedirectTo('/pdv/find')}>PDV</Navbar.Item>
            <Navbar.Item dropdown hoverable>
              <Navbar.Link>Mais</Navbar.Link>
              <Navbar.Dropdown>
                <Navbar.Item onClick={()=>setRedirectTo('/notifications')}>Notificações</Navbar.Item>
                <Navbar.Item onClick={()=>setRedirectTo('/questions')}>Perguntas</Navbar.Item>
                <Navbar.Item>Estacionamento</Navbar.Item>
                <Navbar.Divider />
                <Navbar.Item>Financeiro</Navbar.Item>
              </Navbar.Dropdown>
            </Navbar.Item>
          </Navbar.Segment>

          <Navbar.Segment align="end" className="navbar-item">
              <Dropdown align="right" hoverable>
                <Dropdown.Trigger>
                  <Button className="button" color="custom-purple" outlined>
                    <span>{firstAndLastName}</span>
                    <Icon size="small">
                      <FontAwesomeIcon icon={faAngleDown} />
                    </Icon>
                  </Button>
                </Dropdown.Trigger>
                <Dropdown.Menu>
                  <Dropdown.Content>
                    { user.role==='adm' && <Dropdown.Item onClick={()=>setRedirectTo('/user/new')}>Novo Usuário do Sistema</Dropdown.Item> }
                    <Dropdown.Item onClick={()=>setRedirectTo('/user/edit')}>Editar Minha Conta</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={e => logout()}>Sair</Dropdown.Item>
                  </Dropdown.Content>
                </Dropdown.Menu>
              </Dropdown>
          </Navbar.Segment>
        </Navbar.Menu>
      </Container>
    </Navbar>
  )
}

export default HeaderLogged;
